import styles from 'styles/modules/ProfileHeader.module.scss';
import ProfileBio from './ProfileBio';
import ProfileSidebar from './ProfileSidebar';

const ProfileHeader = (props) => {
    // todo: refactor ProfileSidebar and ProfileBio
    return (
        // Bio first in the DOM so the member's name is the first thing a crawler
        // reads; the sidebar is put back on the left visually with `order`.
        <div className={['mb-l', styles.profileHeader].join(' ')}>
            <ProfileBio {...props} />
            <ProfileSidebar {...props} />
        </div>
    );
};

export default ProfileHeader;
